module.exports = __webpack_public_path__ + "static/media/alta-formazione.1363f5cf.svg";